<template>
  <div
    class="inlineGallery"
  >
    <InlineGalleryCard
      v-for="(image, index) in currentPlayerImages"
      :key="index"
      :path="image.path"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import InlineGalleryCard from './InlineGalleryCard.vue';

export default {
  name: 'inlineGllery',
  components: {
    InlineGalleryCard,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters(['currentPlayerImages']),
    imagesAvailable() {
      // return !(!this.images) && !(!this.images[0]);
      return this.currentPlayerImages !== null;
    },
    theImages() {
      return this.currentPlayerImages;
    },
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.inlineGallery {
  width: 100%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
@media only screen and (orientation : landscape) {
  .inlineGallery {
    width: auto;
    height: 100%;
    margin-left: 2vw;
  }
}
</style>
